module.exports = __webpack_public_path__ + "media/images/equipments-img-01-b29f5cc18d21a11dbb4ecc2e835efecb.jpeg";